/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditSteps/SaveAction",
  disabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  disabled
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 disabled={disabled}
 text="Save"
/>
{children}
</React.Fragment>)
}